import { fromJS } from 'immutable';

import {
  LOAD_DELIVERABLE_SUCCESS,
  LOAD_DELIVERABLE_ERROR,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_ERROR,
  CLEAR_DELIVERABLE,
  LOAD_DELIVERABLE,
  UPDATE_DELIVERABLE_DOCUMENT_STATE,
  CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS,
} from './constants';

const initialState = fromJS({
  loading: false,
  data: null,
  error: null,
  selectedDocument: {},
  mostRecentDocument: {},
  selectedVersion: 1,
  documentVersionOptions: [],
  commentError: null,
});

function deliverableReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_DELIVERABLE:
    return state
      .set('data', null)
      .set('paginatedComments', fromJS([]))
      .set('loading', true);
  case LOAD_DELIVERABLE_SUCCESS:
    return state
      .set('data', action.data)
      .set('selectedDocument', action.selectedDocument)
      .set('documentVersionOptions', action.documentVersionOptions)
      .set('selectedVersion', action.selectedVersion)
      .set('mostRecentDocument', action.mostRecentDocument)
      .set('error', null)
      .set('loading', false);
  case LOAD_DELIVERABLE_ERROR:
    return state.set('loading', false).set('error', action.data);
  case CREATE_COMMENT_SUCCESS:
    return state
      .setIn(['data', 'comments'], action.comments)
      .set('commentError', null);
  case CREATE_COMMENT_ERROR:
    return state.set('commentError', action.error);
  case UPDATE_DELIVERABLE_DOCUMENT_STATE:
    return state
      .setIn(['data', 'document'], action.document)
      .setIn(
        ['data', 'documents', action.document.get('version')],
        action.document,
      )
      .set('mostRecentDocument', action.document);
  case CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS:
    return state
      .set('selectedDocument', action.selectedDocument)
      .set('selectedVersion', action.selectedVersion);
  case CLEAR_DELIVERABLE:
    return initialState;
  default:
    return state;
  }
}

export default deliverableReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable/reducer.js
 **/